<template>
  <div class="d-flex flex-wrap abacus-oo-giftcards-confirmpayment bg-white">
    <!-- Left -->
    <div class="col-12 col-sm-8 p-3 left-section">
      <div class="left-section__main">
        <form @submit.prevent="onSubmit">
          <div v-if="isAddCard" class="add-card">
            <checkout-component
              ref="myDetails"
              :bus="bus"
              :paymentMethod="giftCardPaymentMethod"
              @checkOutValidation="checkOutValidation"
              :edit-model="detailModel"
              :cardModel="paymentModel"
              :storeid="storeid"
            >
              <div class="stripePaymentSection">
                <StripePayComponent
                  class="my-4"
                  :bus="bus"
                  :enableApplePay="true"
                  :enableGooglePay="true"
                  :customGooglePayImage="true"
                  :customApplePayImage="false"
                  @stripe-click="stripePayBtnClicked"
                  @proccessing="updateProcessing"
                  @stripePayTokenGenerated="stripePayTokenGenerated"
                  @finalize="stripePaymentFinalized"
                  ref="stripePayRef"
                  :storeId="storeid"
                />
              </div>
            </checkout-component>

            <button
              type="submit"
              class="btn btn-primary btn-block mt-2"
              style="border-radius: 4px"
              :style="styles.btn"
            >
              Confirm Payment
            </button>
          </div>

          <div v-show="error" class="w-100 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
      </div>
      <div v-if="isMobile()" class="text-center mt-4 body left-footer">
        Powered By
        <img
          class="footer-image"
          src="../../../assets/images/logos/ABACUS_Logo_White.svg"
          alt="abacus white logo"
        />
      </div>
    </div>

    <!-- Right -->
    <div class="col-12 col-sm-4 p-3 right-section">
      <div class="right-top-section px2">My Order</div>
      <div class="right-bottom-section px2">
        <div class="cart-items-wrapper">
          <!-- color style here is tricky, it really depends on the photo color -->
          <div
            v-for="(giftCardItem, index) in giftCartItems"
            :key="giftCardItem.id"
          >
            <div class="container">
              <div class="card-container mt-4">
                <Card
                  :imageUrl="getBackgroundImage(giftCardItem)"
                  :cardContent="giftCardItem.name"
                  :cardValue="giftState.cardValue"
                  :colorStyle="index === 1 ? '#5D77BC' : ''"
                  :giftItem="giftCardItem"
                />
              </div>

              <div
                class="d-flex mt-4 justify-content-between align-items-center"
              >
                <div>
                  <b>${{ giftCardItem.price }}.00</b>
                </div>
                <!-- <div>
                  <a
                    href=""
                    class="link edit"
                    @click.prevent="editCard(giftCardItem)"
                    >Edit Card</a
                  >
                </div> -->
                <div class="numbers-container">
                  <div class="w-100 pb-1 my-2 d-flex">
                    <button
                      :style="desktopStyles.CommonColorTxt"
                      :disabled="giftCardItem.quantity <= 1"
                      class="btn-white btn-circle d-flex justify-content-center align-items-center"
                      @click="dec(giftCardItem)"
                    >
                      <span class="material-icons bigger-material-icons"
                        >remove_circle_outline</span
                      >
                    </button>
                    <span class="d-flex align-items-center">
                      <strong>{{ giftCardItem.quantity }}</strong>
                    </span>
                    <button
                      :style="desktopStyles.CommonColorTxt"
                      :disabled="giftCardItem.quantity >= 20"
                      class="btn-white btn-circle d-flex justify-content-center align-items-center"
                      @click="inc(giftCardItem)"
                    >
                      <span class="material-icons bigger-material-icons"
                        >add_circle_outline</span
                      >
                    </button>
                  </div>
                </div>
                <div>
                  <a
                    href=""
                    class="link remove"
                    @click.prevent="removeCard(giftCardItem)"
                    >Remove</a
                  >
                </div>
              </div>

              <div class="recipient-info mt-4 pb-5">
                <div class="d-flex justify-content-start">
                  <div class="col-5 p-1 title7">Recipient's Name</div>
                  <div class="col-5 p-1 title7">Recipient's Email</div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="col-5 p-1 title5-5">
                    {{ giftCardItem.message.To }}
                  </div>
                  <div class="col-7 p-1 title5-5" style="word-break: break-all">
                    {{ giftCardItem.message.Email }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-divider" :style="{ color: '#E3E6EA' }"></div>

        <div class="w-divider" :style="{ color: '#E3E6EA' }"></div>

        <!-- coupon -->
        <CouponComponent
          ref="couponComponent"
          :className="'cart-totals'"
          class="p-0 mb-2 mt-4"
          :ForMobile="isMobile()"
        ></CouponComponent>
        <div
          v-for="(coupon, index) in couponList"
          :key="coupon"
          @click="
            () => {
              couponList.splice(index, 1);
            }
          "
          class="coupon-tag p-1"
        ></div>

        <div class="row no-gutters">
          <div class="col-4">Subtotal</div>
          <div class="col-4 offset-4 text-right">
            {{ giftSubTotal | formatMoney }}
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-4">Discount</div>
          <div class="col-4 offset-4 text-right">
            {{ giftDiscount | formatMoney }}
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-4">Surcharge</div>
          <div class="col-4 offset-4 text-right">
            {{ giftSurcharge | formatMoney }}
          </div>
        </div>

        <div class="w-divider mt-2" :style="{ color: '#E3E6EA' }"></div>

        <div class="row no-gutters">
          <div class="col-4">Total</div>
          <div class="col-4 offset-4 text-right">
            {{ giftTotalPrice | formatMoney }}
          </div>
        </div>

        <div class="row no-gutters mt-4">
          <div class="col-12">
            <router-link :to="{ name: 'giftstorev2' }">
              <button
                class="btn continue-ordering px-4"
                style="border-radius: 4px"
                :style="styles.btn"
              >
                Add more gift cards
              </button>
            </router-link>
            <!-- <button class="btn continue-ordering px-4" @click.prevent="$router.replace('giftstorev2')">Continue Ordering</button> -->
          </div>
        </div>

        <GiftCardFooter v-if="!isMobile()" :showSub="false" class="mt-5" />
      </div>
    </div>

    <!-- the overlay for showing transaction dealing progress -->
    <div class="w-overly" v-if="showOverlay">
      <div class="transaction-box transaction-box col-lg-4" v-if="isProcessing">
        <div class="spin-lg"></div>
        <h3 class="text-center">{{ processText }}</h3>
        <p class="text-center w-48">{{ processDescription }}.</p>
      </div>
      <h5
        class="text-center position-absolute top-50 start-50 translate-middle text-white"
        style="bottom: 3rem !important"
      >
        Power by ABACUS
      </h5>

      <!-- when transaction success -->
      <!--      <div-->
      <!--        v-if="!isProcessing && isSuccess"-->
      <!--        class="transaction-box transaction-box col-4 success-box"-->
      <!--      >-->
      <!--        <img-->
      <!--          src="../../../assets/images/icons/transaction-success.png"-->
      <!--          class="transaction-icon"-->
      <!--          alt="payment success"-->
      <!--        />-->
      <!--        <h3 class="text-center">Payment Complete</h3>-->
      <!--      </div>-->

      <!-- when transaction is failed -->
      <div
        v-if="!isProcessing && !isSuccess"
        class="transaction-box col-lg-4 error-box"
      >
        <img
          src="../../../assets/images/icons/transaction-failed.png"
          class="transaction-icon"
          alt="payment failed"
        />
        <h3 class="text-center text-white">Payment could not be processed</h3>
        <router-link :to="{ name: 'giftstorev2' }">
          <button class="btn body text-white">Continue Ordering</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import Card from "./Card.vue";
import GiftCardFooter from "./GiftCardFooter.vue";
import CouponComponent from "../../../components/shop/shopping-cart/CouponComponent.vue";
//import shared from "../scripts/giftCheckout.js";
import shares from "../../../sharedscripts/shop/shopping-cart/ShoppingCart";
import CheckoutComponent from "./CheckoutComponent.vue";
import StripePayComponent from "../../../components/shop/Checkout/partials/StripePay.vue";
import uuid from "uuid/v1";
import { DefaultPaymentHandler } from "../../../api/payment/DefaultPaymentHandler.js";
export default {
  directives: { mask },
  components: {
    Card,
    CouponComponent,
    GiftCardFooter,
    CheckoutComponent,
    StripePayComponent,
  },
  data() {
    return {
      bus: new Vue(),
      showStripePayment: false,
      showOverlay: false,
      progress: 0,
      isProcessing: false,
      isSuccess: true,
      couponList: [],
      isAddCard: true,
      isGoogle: false,
      couponCode: null,
      giftcardCode: 111,
      giftState: this.$store.getters["newGiftShoppingCart/allGiftState"],
      cardCVC: null,
      cardDate: null,
      cardNumber: null,
      email: null,
      giftcardItem: null,
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null,
      },
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      guestUserId: null,
      store: null,
      error: "",
    };
  },
  computed: {
    ...mapGetters(["currentStoreDoc", "desktopStyles", "styles"]),
    //...shared.computed,
    processText: {
      get() {
        return this.isProcessing
          ? this.$t("message.processingPayment")
          : this.isSuccess
          ? // ? this.$t("message.paymentComplete")
            ""
          : this.$t("message.paymentCouldNotBeProcessed");
      },
    },
    giftCardPaymentMethod: {
      get() {
        return this.$store.getters["newGiftShoppingCart/paymentMethod"];
      },
    },
    processDescription: {
      get() {
        return this.isProcessing
          ? this.$t(
              "message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed"
            )
          : "";
      },
    },
    giftDiscount: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftDiscount"];
      },
    },
    giftSurcharge: {
      get() {
        return this.$store.getters["getGiftSurchargeAmount"];
      },
    },
    giftSubTotal: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftCartValue"];
      },
    },
    giftTotalPrice: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftTotalPrice"];
      },
    },
    giftCartItems: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftCartItems"];
      },
    },
    giftUsedCoupons: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftUsedCoupons"];
      },
    },
    hqDoc: {
      get() {
        return this.$store.getters["hqDoc"];
      },
    },
    selectedCompany: {
      get() {
        return this.$store.getters["selectedCompany"];
      },
    },
    storeMenu: {
      get() {
        return this.$store.getters["storeMenu"];
      },
    },
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    },
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
  },
  created() {
    this.store = this.currentStoreDoc;
    if (this.giftCartItems.length == 0) {
      this.$router.push({
        name: "giftstorev2",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename,
          isGift: true,
        },
      });
    }
  },
  methods: {
    ...shares.methods,
    //...shared.methods,
    createUserModel() {
      var userID = "";
      var firstName = "";
      var lastName = "";
      var displayName = "";
      var phone = "";
      var email = "";
      var isguest = true;

      firstName = firstName || this.detailModel.FirstName || "";
      lastName = lastName || this.detailModel.LastName || "";
      email = email || this.detailModel.Email || "";
      phone = this.detailModel.Phone || "";
      displayName = firstName + " " + lastName;
      return {
        IsGuest: isguest,
        ID: userID,
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DisplayName: displayName.trim(),
        Phone: phone.trim(),
        Email: email.trim(),
      };
    },
    createCardModel() {
      let exDate = this.paymentModel.ExpireDate.split("/");
      let isToken = false;
      let useCard = !isToken && this.giftCardPaymentMethod == 1;
      return {
        exclude: !useCard,
        isToken: isToken,
        token: isToken ? this.paymentModel.SelectedCard.CardIdentifier : "",
        cvc: this.paymentModel.CVV,
        expMonth: exDate[0],
        expYear: useCard ? exDate[1] : "",
        number: this.paymentModel.CardNumber,
        holder: `${this.detailModel.FirstName} ${this.detailModel.LastName}`,
      };
    },
    navigateSuccess() {
      this.$router.push({
        name: "giftCardOrderComplete",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename,
          isGift: true,
        },
      });
    },
    stripePaymentFinalized() {
      localStorage.removeItem("giftCheckoutData");
      this.error = "";
      this.isProcessing = false;
      this.isSuccess = true;
      // setTimeout(() => {
      this.navigateSuccess();
      this.$store.dispatch("newGiftShoppingCart/clearGiftCart");
      this.$store.dispatch("newGiftShoppingCart/clearGiftCoupon");
      // }, 2000);
    },
    processPaymentForCard() {
      let payment = new DefaultPaymentHandler();
      let udid = uuid();
      let cardModel = this.createCardModel();
      let userModel = this.createUserModel();
      let orderInfo = { orderType: this.orderType };
      let guestUserId = uuid();
      let that = this;
      const stripe = that.$stripe;
      const cardElement = this.$refs.myDetails.getCardElement();
      payment
        .MakePaymentv2(
          udid,
          cardModel,
          userModel,
          this.currentStoreDoc,
          orderInfo,
          guestUserId,
          this.giftCardPaymentMethod,
          stripe,
          cardElement,
          true,
          this.giftUsedCoupons,
          undefined,
          false
        )
        .then((res) => {
          that.processPaymentResponse(res);
        })
        .catch((msg) => {
          that.processPaymentException(msg);
        });
    },
    processPaymentForStripe(trackingOrder) {
      let payment = new DefaultPaymentHandler();
      let that = this;
      payment
        .MakePaymentByTrackingOrder(
          trackingOrder,
          trackingOrder.TrackingOrder.UDID
        )
        .then((res) => {
          that.processPaymentResponse(res);
        })
        .catch((msg) => {
          that.processPaymentException(msg);
        });
    },
    processPaymentException(msg) {
      console.error(msg);
      this.isProcessing = false;
      this.error = this.$t("message.apiTimeoutMessage", {
        msg: `<a class="sc-jZIEzD edcGpI" href="mailto:support@abacus.co" title="mailto:support@abacus.co">support@abacus.co</a>`,
      });
    },
    processPaymentResponse(res) {
      this.isProcessing = false;
      if (res.data.Success === true) {
        localStorage.removeItem("giftCheckoutData");
        this.error = "";
        this.isProcessing = false;
        this.isSuccess = true;
        // setTimeout(() => {
        this.navigateSuccess();
        this.$store.dispatch("newGiftShoppingCart/clearGiftCart");
        this.$store.dispatch("newGiftShoppingCart/clearGiftCoupon");
        // }, 2000);
      } else {
        this.error = res.data.Status.Message;
        this.isProcessing = false;
        this.isSuccess = false;
        // setTimeout(() => {
        this.showOverlay = false;
        // }, 3000);
      }
    },
    checkOutValidation(result) {
      if (!result) {
        return;
      }
      this.error = "";
      //card
      if (this.giftCardPaymentMethod == 1) {
        this.isProcessing = true;
        this.processPaymentForCard();
      }
      //Stripe
      else {
        let payment = new DefaultPaymentHandler();
        let udid = uuid();
        //let cardModel = this.createCardModel();
        let userModel = this.createUserModel();
        let orderInfo = { orderType: 10 };
        let guestUserId = uuid();

        //currentStoreDoc
        var trackingOrderModel = payment.MakePaymentBody(
          udid,
          null,
          userModel,
          this.selectedCompany,
          orderInfo,
          guestUserId,
          this.giftCardPaymentMethod,
          true,
          this.giftUsedCoupons,
          undefined,
          false
        );
        this.$refs.stripePayRef.setTrackingOrder(trackingOrderModel);
        this.$refs.stripePayRef.showPayment();
      }
      //start to place order
    },
    updateProcessing(status) {
      this.isProcessing = status;
    },
    setCardNumber() {
      this.$store.dispatch("setCardNumber");
    },
    clearCardType() {
      this.$store.dispatch("clearCardType");
    },
    setStoreLoaded() {
      this.$store.commit("setStoreLoaded");
    },

    // returns false if editModel isnt complete
    validateOrderDetails(detailModel) {
      if (!detailModel) return false;
      const { FirstName, Phone, Email } = detailModel;
      return !(!FirstName || !Phone || !Email);
    },

    // returns false if paymentModel isnt complete
    validateCardDetails(paymentModel) {
      // return true if user is paying with previous card
      if (this.paymentModel.SelectedCard) return true;
      if (!paymentModel) return false;
      const { CardNumber, ExpireDate, CVV } = paymentModel;
      return !(!CardNumber || !ExpireDate || !CVV);
    },
    //Card Payment
    async onSubmit() {
      const isValid = this.runValidation();
      if (!isValid) {
        return;
      }
      const isDetailsValid = this.validateOrderDetails(this.detailModel);
      if (!isDetailsValid) {
        this.error = "Please enter all fields";
        return;
      }
      this.error = "";
      this.showOverlay = true;
      this.isProcessing = true;
      this.$store.commit("newGiftShoppingCart/setPaymentMethod", 1);
      this.bus.$emit("validateCheckOutInfo");
    },
    //Stripe Payment
    stripePayTokenGenerated(trackingOrder) {
      this.showOverlay = true;
      this.isProcessing = true;
      this.processPaymentForStripe(trackingOrder);
    },
    //Stripe Payment
    stripePayBtnClicked(paymentMethod) {
      const isValid = this.runValidation();
      if (!isValid) {
        return;
      }
      this.$store.commit("newGiftShoppingCart/setPaymentMethod", paymentMethod);
      this.bus.$emit("validateCheckOutInfo");
    },
    getBackgroundImage(item) {
      if (item && item.photoUrl) return item.photoUrl;
      else return item.localPhotoUrl;
    },
    editCard(item) {
      this.$store.commit("newGiftShoppingCart/REMOVE_GIFTCART_ITEM", {
        item: item,
      });
      this.$router.push({
        name: "giftcardLandingPage",
        params: {
          metaData: JSON.stringify({
            id: item.id,
            buyFor: item.buyFor,
            message: item.message,
          }),
        },
      });
    },
    removeCard(item) {
      this.$store.commit("newGiftShoppingCart/REMOVE_GIFTCART_ITEM", {
        item: item,
      });
      if (this.giftCartItems.length == 0) {
        this.$router.push({
          name: "giftcardLandingPage",
          // params: {
          //   metaData: JSON.stringify({
          //       id:  item.id,
          //       buyFor: item.buyFor,
          //       message: item.message
          //   })
          // }
        });
      }
      // else
      // {
      //     //this is for updating the google pay amount
      //     this.bus.$emit('giftTotalPriceUpdated', {
      //         amount: this.$store.getters['newGiftShoppingCart/giftTotalPrice']
      //     });
      // }
    },
    setShowGooglePay(show) {
      this.showGooglePay = show;
    },
    inc(giftCardItem) {
      this.$store.commit("newGiftShoppingCart/UpdateGiftItemQuantity", {
        item: {
          ...giftCardItem,
        },
        quantity: giftCardItem.quantity + 1,
      });
    },
    dec(giftCardItem) {
      this.$store.commit("newGiftShoppingCart/UpdateGiftItemQuantity", {
        item: {
          ...giftCardItem,
        },
        quantity: giftCardItem.quantity - 1,
      });
    },
    validateProductID() {
      const allMenus = this.$store.getters["getAllStoreMenus"];
      const menu = allMenus.find((menu) => menu.id == "DefaultMenu");
      const giftItems = this.giftCartItems;
      const storeGiftCards = [];
      if (
        menu &&
        menu.SpecialCategories &&
        menu.SpecialCategories.SCTypeGiftcard &&
        menu.SpecialCategories.SCTypeGiftcard.SubMenuItems
      ) {
        menu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach((element) => {
          if (element.ProductID) {
            storeGiftCards.push(element.ProductID);
          }
        });
      }
      
      // Find any gift items that don't exist in storeGiftCards
      const invalidGiftItems = giftItems.filter(giftItem => !storeGiftCards.includes(giftItem.id));
      
      if (invalidGiftItems.length > 0) {
        // Remove invalid gift items from cart
        invalidGiftItems.forEach(item => {
          this.$store.commit("newGiftShoppingCart/REMOVE_GIFTCART_ITEM", {
            item: item
          });
        });
      }
      
      return !invalidGiftItems.length;
    },
    runValidation() {
      const validationResult = this.validateProductID();
      if (!validationResult || !this.giftCartItems.length) {
        this.error = "Invalid Gift Card ID. Please try again.";
        return false;
      }
      return true;
    } 
  },
  watch: {
    giftTotalPrice() {
      this.bus.$emit("giftTotalPriceUpdated", {
        amount: this.$store.getters["newGiftShoppingCart/giftTotalPrice"],
      });
    },
    "$store.state.newGiftShoppingCart.giftTotalPrice": function () {
      this.storegiftComputeRules();
    },
    "paymentModel.CardNumber": function (val) {
      this.$validator.validate("cardNumber").then((res) => {
        setTimeout(() => {
          if (res) this.setCardNumber(val);
          else this.clearCardType();
        }, 1);
      });
    },
    "paymentModel.ExpireDate": function (newValue) {
      if (newValue.length > 4) {
        let splitedValue = newValue.split("/");
        if (splitedValue[0] > 12) {
          this.editModel.ExpireDate = splitedValue[1] + "/" + splitedValue[0];
        } else if (splitedValue[1].length > 3) {
          this.editModel.ExpireDate =
            splitedValue[0] + "/" + splitedValue[1].slice(-2);
        }
      }
    },
  },
  mounted() {
    this.setStoreLoaded();
  },
};
</script>

<style scoped>
.spin-lg::after {
  content: "" !important;
  position: absolute !important;
  width: 5rem !important;
  height: 5rem !important;
  border: 3px solid white !important;
  border-radius: 100% !important;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  -webkit-animation: rotate 0.7s infinite linear !important;
  animation: rotate 0.7s infinite linear !important;
}

.cart-items-wrapper a.edit {
  color: #0d6efd !important;
}

.cart-items-wrapper a.remove {
  color: #dc3545 !important;
}

.w-divider {
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-top-width: 1px;
}

.w-overlay[data-v-648cce40] {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.w-overlay {
  z-index: 500;
  position: fixed;
  top: -10px;
  left: -10px;
  bottom: -10px;
  right: -10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
  height: 8%;
}
.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  top: 10px;
  right: 45px;
}

@media only screen and (min-width: 1200px) {
  .left-section__main {
    padding: 5% 20% 10%;
    height: 92%;
  }
}
.giftcard-wrapper {
  height: 92%;
  width: 100%;
  padding: 2% 24%;
  box-sizing: border-box;
}
.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  margin: 0 2%;
  width: auto;
  height: 8%;
}
.right-top-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
  height: 5%;
}

.btn-block {
  width: 100%;
}
.gpay-button {
  border: 1px solid #d3d8de;
  border-radius: 4px;
  padding: 0.3rem;
}
.purchase_image {
  width: 16%;
}
.form-control {
  padding-top: 0;
  padding-bottom: 0;
}
.form-control::placeholder {
  font-size: 0.7rem;
  font-weight: 400;
  color: #969da2;
}
input input:focus {
  outline: none;
  -webkit-appearance: none;
}
.coupon-tag {
  background-color: #3862eb;
  font-size: 0.8rem;
  color: rgb(255, 255, 255);
  width: fit-content;
  border-radius: 4px;
}
.pointer:hover {
  cursor: pointer;
}
.footer-image {
  width: 35%;
  margin-top: -4px;
}
.w-overlay {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.right-section {
  background-color: #fafafa;
  overflow: hidden;
}

@media only screen and (max-width: 900px) {
  #top {
    background-image: none;
    height: 0;
  }
  .gift-card-button {
    color: #55a7ff;
    z-index: 2;
    border: none;
  }

  .right-section {
    order: 1;
    -webkit-order: 1;
    background-color: #ffffff;
    height: fit-content;
    overflow: visible;
  }
  .left-section {
    order: 2;
    -webkit-order: 2;
  }
  .right-top-section {
    border: none;
    font-size: 20px;
    font-weight: 400;
    margin-top: 1rem;
  }
  #button-addon2 {
    border-radius: 0;
    background-color: #000000;
    color: #ffffff;
    margin-left: 1rem;
  }
  .sum-section {
    margin-top: 1rem;
  }
  .gpay-button {
    width: 100%;
  }

  .left-footer {
    margin-top: 0.5rem;
  }
}
.title7 {
  font-size: 14px;
  font-weight: 400;
  color: #969da2;
}
.title5-5 {
  font-size: 14px;
  font-weight: 500;
  color: #767575;
}

.w-overly {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.w-overly {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 500;
  position: fixed;
  top: -10px;
  left: -10px;
  bottom: -10px;
  right: -10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}
.transaction-icon {
  width: 100px;
}
.transaction-box {
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.error-box h3 {
  color: red;
}
.error-box button {
  background-color: #f65555;
}

.success-box h3 {
  color: green;
}
</style>
